var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typeform-shoppping"},[_c('a',{staticClass:"typeform-share button typeform-share-hidden",attrs:{"href":_vm.finalUrl,"data-mode":"drawer_right","data-auto-open":"true","data-submit-close-delay":"10"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }